var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 11,
    viewBox: "0 0 17 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8346 3.85098L12.8109 0.285645L11.8785 1.38494L14.6887 4.69917L0.587769 4.72249V6.27737L14.7282 6.25404L11.8779 9.61491L12.8102 10.7142L15.8346 7.14888C16.2043 6.7108 16.4119 6.11794 16.4119 5.49993C16.4119 4.88192 16.2043 4.28906 15.8346 3.85098Z",
    fill: "#0F1B63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8346 3.85098L12.8109 0.285645L11.8785 1.38494L14.6887 4.69917L0.587769 4.72249V6.27737L14.7282 6.25404L11.8779 9.61491L12.8102 10.7142L15.8346 7.14888C16.2043 6.7108 16.4119 6.11794 16.4119 5.49993C16.4119 4.88192 16.2043 4.28906 15.8346 3.85098Z",
    fill: "black",
    fillOpacity: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.dbb2c8ffe3f52eb5a3de354a70e71cf2.svg";
export { ForwardRef as ReactComponent };